import { ChevronRight } from "@carbon/icons-react";
import { OfferAwardedForDeliveryResponse } from "../../../types";

type AwardedTableRowProps = {
  awardedOrdersSuppliers: OfferAwardedForDeliveryResponse;
  handleSupplierSelect: (item: OfferAwardedForDeliveryResponse) => void;
};

const AwardedTableRow = ({
  awardedOrdersSuppliers,
  handleSupplierSelect,
}: AwardedTableRowProps) => {
  return (
    <tr key={awardedOrdersSuppliers.supplier.id}>
      <td
        className="px-2 py-2 whitespace-nowrap text-xxs text-gray-900 uppercase font-semibold"
        onClick={() => handleSupplierSelect(awardedOrdersSuppliers)}
      >
        {awardedOrdersSuppliers.orderSummary.name}
      </td>
      <td className="px-2 py-2 whitespace-nowrap text-xxs text-gray-900 uppercase font-semibold">
        {awardedOrdersSuppliers.supplier.companyName}
      </td>
      <td className="px-2 py-2 whitespace-nowrap text-xxs text-gray-500">
        {awardedOrdersSuppliers.supplier.firstName}{" "}
        {awardedOrdersSuppliers.supplier.lastName}
      </td>
      <td className="px-2 py-2 whitespace-nowrap text-xxs text-gray-500">
        {awardedOrdersSuppliers.supplier.email}
      </td>
      <td className="px-2 py-2 whitespace-nowrap text-xxs text-gray-500">
        {awardedOrdersSuppliers.offers.length}
      </td>
      <td className="relative whitespace-nowrap py-2 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
        <button
          onClick={() => handleSupplierSelect(awardedOrdersSuppliers)}
          className="text-spectum hover:text-spectum-light"
        >
          <ChevronRight size={20} />
        </button>
      </td>
    </tr>
  );
};

export default AwardedTableRow;
